(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shift-type', {
                parent: 'entity',
                url: '/shift-type',
                data: {
                    authorities: [],
                    pageTitle: 'ShiftTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shift-type/list/shift-type.html',
                        controller: 'ShiftTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Shift Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE, access);
                }]
            });
    }
})();
